import styled, { css } from 'styled-components'

export const StyledTabs = styled.div`
  align-items: center;
  display: flex;
`

const activeTab = css`
  color: ${({ theme }) => theme.colors.textBody};
  font-weight: 700;
  line-height: 20px;

  a {
    color: ${({ theme }) => theme.colors.textBody} !important;
  }

  &::after {
    background: ${({ theme }) => theme.colors.primary};
  }
`

export const StyledTab = styled.div<{ active?: boolean }>`
  color: ${({ theme }) => theme.colors.textCaption};
  cursor: pointer;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  position: relative;

  a {
    color: ${({ theme }) => theme.colors.textCaption} !important;
  }

  &::after {
    content: '';
    background: transparent;
    border-radius: 19px;
    bottom: -5px;
    display: block;
    height: 2px;
    left: calc(50% - 10px);
    position: absolute;
    width: 20px;
  }

  ${({ active }) => (active ? activeTab : null)}
`

export const StyledPipe = styled.div`
  background: ${({ theme }) => theme.colors.borderDefault};
  height: 12px;
  margin: 0 20px;
  opacity: 0.7;
  width: 1px;
`
